import { render, staticRenderFns } from "./CommonQuestions.vue?vue&type=template&id=23b250e8&scoped=true&"
import script from "./CommonQuestions.vue?vue&type=script&lang=js&"
export * from "./CommonQuestions.vue?vue&type=script&lang=js&"
import style0 from "./CommonQuestions.vue?vue&type=style&index=0&id=23b250e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b250e8",
  null
  
)

export default component.exports